import { useMutation } from '@tanstack/react-query';
import { POST, POST_LOGOUT_DEALER } from '../../../services';
import { openAlert } from '../../../components/alert/hooks';
import { removeCookies } from '../../../store/useCookies';
import { ROUTES_PATH } from '../../../resources/routes-name';
import { navigateTo } from '../../../utils/navigation';

export const useLogoutDealer = () =>
  useMutation({
    mutationFn: async (value) => {
      const response = await POST(POST_LOGOUT_DEALER(), value);
      return response;
    },
    onSuccess: (data) => {
      openAlert({ model: 'message', type: 'success', message: data?.message });
      removeCookies('accessToken');
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      navigateTo({ pathname: ROUTES_PATH.ROUTE_LOGIN_DEALER.PATH });
    },
    onError: (error) => {
      openAlert({ model: 'message', type: 'error', message: error?.message });
    },
  });
